<div class="input-group">
    <div class="input-group-prepend bg-custom b-0">
      <ng-container *ngIf="textSearch != '' ">
        <button class="input-group-text bg-secondary text-white pointer" (click)="clear(); searchInput.focus()">
          <i class="far fa-trash-alt"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="textSearch == '' ">
        <span class="input-group-text"><i class="fas fa-search"></i></span>
      </ng-container>
    </div>
      <input type="text" class="form-control" id="search" placeholder="Ingrese el nombre del item a buscar"
        (keyup)="debouncedSearch($event)" (paste)="debouncedSearch($event)" [(ngModel)]="textSearch" #searchInput autocomplete="off" />
  </div>
  